export default "__VITE_ASSET__6Yako651__"